import { render, staticRenderFns } from "./ViewSidebar.vue?vue&type=template&id=04d4480a&scoped=true"
import script from "./ViewSidebar.vue?vue&type=script&lang=js"
export * from "./ViewSidebar.vue?vue&type=script&lang=js"
import style0 from "./ViewSidebar.vue?vue&type=style&index=0&id=04d4480a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d4480a",
  null
  
)

export default component.exports